export default __webpack_public_path__ + "static/media/esgot-screenshot-03.237b1e9f.png";